import { render, staticRenderFns } from "./FormGeneralRecordStreamax.vue?vue&type=template&id=bf51d824&scoped=true&"
import script from "./FormGeneralRecordStreamax.vue?vue&type=script&lang=ts&"
export * from "./FormGeneralRecordStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./FormGeneralRecordStreamax.vue?vue&type=style&index=0&id=bf51d824&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf51d824",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bf51d824', component.options)
    } else {
      api.reload('bf51d824', component.options)
    }
    module.hot.accept("./FormGeneralRecordStreamax.vue?vue&type=template&id=bf51d824&scoped=true&", function () {
      api.rerender('bf51d824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfiguracionCamaras/Streamax/Record/FormGeneralRecordStreamax.vue"
export default component.exports